export const PROPERTY_TYPE_OPTIONS = [
  'Vivienda',
  'Garaje',
  'Habitación',
  'Local',
  'Nave',
  'Oficina',
  'Parcela',
];

export const GUARANTEE_TYPE_OPTIONS = [
  'Garantía indefinida',
  'Garantía temporal',
  'Defensa jurídica',
];

export const GUARANTEE_TYPE_INFO = [
  {
    value: 'Garantía indefinida',
    description: 'Cobertura completa durante toda la duración del contrato de alquiler',
    link: 'https://www.seag.es/prestaciones-seguro-impago-alquiler/',
  },
  {
    value: 'Garantía temporal',
    description: 'Cobertura por un período determinado de tiempo',
    link: 'https://www.seag.es/garantia-temporal-mejor-que-seguro-impago-alquiler/',
  },
  {
    value: 'Defensa jurídica',
    description: 'Asesoramiento y defensa legal en conflictos de alquiler',
    link: 'https://www.seag.es/prestaciones-adicionales/',
  },
];

export const MONTHS_OPTIONS = ['01', '02', '03', '04', '05', '06'];

export const ROLE_OPTIONS = ['Inquilino', 'Avalista'];

export const PERSON_TYPE_OPTIONS = ['Persona física', 'Persona jurídica'];

export const DOCUMENT_TYPE_OPTIONS = ['DNI', 'NIE', 'Pasaporte'];

export const ADDITIONAL_OPTIONS = ['Con opción a compra', 'Para rent to rent'];
